import { SNACKBAR_HIDE, INFO_MESSAGE_SHOW } from '../constants/snackbar';

export const hideSnackbar = () => {
    return {
        type: SNACKBAR_HIDE,
    };
};

export const showInfoMessage = (message) => {
    return {
        type: INFO_MESSAGE_SHOW,
        message,
    };
};
